module.exports = __webpack_public_path__ + "static/media/nehas-bags.a7196463.png";